import { reducer, on } from "ts-action";
import type { bookmark } from "@progressive-development/politik-model";
import { loadBookmarks, addBookmark, updateBookmark, deleteBookmark } from "./bookmarks-actions.js";

/**
 * Reducer der Merkliste.
 *
 * Der Store ist die Session-Wahrheit: add/update/delete pflegen die Liste aus
 * den success-Payloads — im Mock-Modus (zustandslose Fixtures) ist das die
 * einzige Persistenz, im Firebase-Modus spart es den Re-Fetch nach Writes.
 */

export interface BookmarksState {
  /** undefined = noch nie geladen; [] = geladen und leer (Empty State). */
  bookmarks?: bookmark.Bookmark[];
}

const initialState: BookmarksState = {};

export const bookmarksReducer = reducer<BookmarksState>(
  initialState,
  on(loadBookmarks.success, (state, { payload }) => ({
    ...state,
    bookmarks: payload,
  })),
  on(addBookmark.success, (state, { payload }) => ({
    ...state,
    bookmarks: [payload, ...(state.bookmarks ?? [])],
  })),
  on(updateBookmark.success, (state, { payload }) => ({
    ...state,
    bookmarks: (state.bookmarks ?? []).map((b) => (b.id === payload.id ? payload : b)),
  })),
  on(deleteBookmark.success, (state, { payload }) => ({
    ...state,
    bookmarks: (state.bookmarks ?? []).filter((b) => b.id !== payload.id),
  })),
);
